import { LinkProps } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import { type ReactNode } from 'react'
import { cn } from '~/utils'
import { Link } from '../elements'

export type BreadcrumbPage = { name: string; leading?: ReactNode; trailing?: ReactNode } & Pick<
  LinkProps,
  'to' | 'params' | 'search'
>
type BreadcrumbsProps = {
  pages?: BreadcrumbPage[]
  className?: string
  role?: string
}

export const Breadcrumbs = ({ pages = [], role = 'list', className, ...props }: BreadcrumbsProps) => {
  return (
    <div {...props} role={role} className={cn('flex items-center gap-1', className)}>
      {pages.map(({ name, leading, trailing, ...pageProps }, i) => (
        <div key={name} className="flex max-w-full min-w-0 shrink items-center gap-1">
          {i > 0 && <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />}
          {leading}
          {pageProps.to ? (
            <Link {...pageProps} className="truncate text-sm text-gray-500 hover:text-gray-700">
              {name}
            </Link>
          ) : (
            <span className="truncate text-sm font-medium text-neutral-900">{name}</span>
          )}
          {trailing}
        </div>
      ))}
    </div>
  )
}
